import React from "react";
import { Instagram } from "lucide-react";
import { instagramPosts } from "../mock";
import { SectionTitle } from "./ShopByAge";

const NAVY = "#1B1F5C";

const InstagramFeed = () => {
  return (
    <section className="py-10 md:py-14 bg-white relative overflow-hidden">
      {/* doodle stars */}
      <svg className="absolute top-12 right-8 w-6 h-6 text-[#F0426A] hidden md:block" viewBox="0 0 24 24" fill="currentColor"><path d="M12 2l2.4 7.2L22 12l-7.6 2.8L12 22l-2.4-7.2L2 12l7.6-2.8z"/></svg>
      <svg className="absolute bottom-14 left-8 w-5 h-5 text-[#35C3C1] hidden md:block" viewBox="0 0 24 24" fill="currentColor"><path d="M12 2l2.4 7.2L22 12l-7.6 2.8L12 22l-2.4-7.2L2 12l7.6-2.8z"/></svg>

      <div className="max-w-7xl mx-auto px-4">
        <SectionTitle>Follow Us on Instagram</SectionTitle>
        <div className="flex items-center justify-center gap-2 -mt-4 mb-8">
          <span
            className="h-8 w-8 rounded-full flex items-center justify-center text-white"
            style={{ background: "radial-gradient(circle at 30% 110%, #FDB35D 0%, #E1306C 55%, #C13584 100%)" }}
          >
            <Instagram size={15} />
          </span>
          <p className="text-[13.5px] font-extrabold" style={{ color: NAVY }}>
            @adhiraandappatoys
          </p>
          <span className="text-[12.5px] font-semibold text-gray-500 hidden sm:inline">— joyful moments, new toys & playtime ideas</span>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-4">
          {instagramPosts.map((post) => (
            <a
              key={post.id}
              href="https://www.instagram.com/adhiraandappa__toys/"
              target="_blank"
              rel="noopener noreferrer"
              className="relative rounded-2xl overflow-hidden group aspect-square block"
              aria-label="View Instagram post"
            >
              <img
                src={post.image}
                alt="Adhira & Appa Toys Instagram post"
                className="h-full w-full object-cover group-hover:scale-110 transition-transform duration-500"
                loading="lazy"
              />
              {/* hover overlay */}
              <div className="absolute inset-0 bg-[#1B1F5C]/70 opacity-0 group-hover:opacity-100 flex flex-col items-center justify-center gap-2" style={{ transition: "opacity 300ms ease" }}>
                <Instagram size={24} className="text-white" />
                <span className="text-white text-[11.5px] font-extrabold tracking-wide">View on Instagram</span>
              </div>
            </a>
          ))}
        </div>

        <div className="mt-8 flex justify-center">
          <a
            href="https://www.instagram.com/adhiraandappa__toys/"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 px-7 h-12 rounded-full text-white text-[12px] font-extrabold tracking-widest shadow-md hover:shadow-lg hover:-translate-y-0.5 transition-transform duration-200"
            style={{ backgroundColor: NAVY }}
          >
            <Instagram size={16} /> FOLLOW US ON INSTAGRAM
          </a>
        </div>
      </div>
    </section>
  );
};

export default InstagramFeed;
